import { getRandomString } from './getRandomString'

export const clientId = getRandomString() + getRandomString()
